<template>
  <v-card
    style="border-radius: 10px"
    flat
    :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
  >
    <v-toolbar flat dense class="beez-bold">
      Task Items
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" flat icon @click="tableView = !tableView">
            <v-icon>{{ !tableView ? 'table_chart' : 'view_agenda' }} </v-icon>
          </v-btn>
        </template>
        <span>{{ !tableView ? 'Table View' : 'Card View' }}</span>
      </v-tooltip>
      <v-btn flat icon @click="approvalPanel = !approvalPanel">
        <v-icon>{{ approvalPanel ? 'expand_less' : 'expand_more' }} </v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text v-if="approvalPanel">
      <v-layout align-center justify-space-between row wrap>
        <v-flex grow>
          <v-btn disabled icon flat class="primary">
            <v-icon>list</v-icon>
          </v-btn>
          <span>Total Items : {{ items.length }}</span>
        </v-flex>
        <v-flex grow>
          <v-btn disabled icon flat class="success">
            <v-icon>thumb_up_alt</v-icon>
          </v-btn>
          <span>Approved Items : {{ totalApproved }}</span>
        </v-flex>
        <v-flex grow>
          <v-btn disabled icon flat class="error">
            <v-icon>thumb_down_alt</v-icon>
          </v-btn>
          <span>Rejected Items : {{ totalRejected }}</span>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-space-between row wrap pb-2>
        <v-btn icon @click="searchTerm = ''">
          <v-icon>clear</v-icon>
        </v-btn>
        <v-text-field
          hide-details
          append-icon="search"
          single-line
          color="secondary"
          label="Search Approval items"
          @input="searchApprovalItems"
          v-model="searchTerm"
        >
        </v-text-field>
      </v-layout>
      <v-flex v-if="tableView">
        <v-data-table
          :headers="headers"
          :items="items"
          :search="searchTerm"
          :expand="expand"
          item-key="metric1"
        >
          <template v-slot:items="props">
            <tr @click="props.expanded = !props.expanded">
              <td>
                <div class="text-xs-left" style="word-wrap: break-word">
                  <div class="caption font-weight-bold">
                    {{ props.item.longDescription }}
                  </div>
                  <div class="subheading">
                    {{ props.item.description }}
                  </div>
                </div>
              </td>
              <td>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <div class="text-xs-left" style="word-wrap: break-word">
                      <div class="caption font-weight-bold">
                        {{ props.item.metricCaption1 }}
                      </div>
                      <div class="subheading">
                        {{ props.item.metric1 }}
                      </div>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <div class="text-xs-left" style="word-wrap: break-word">
                      <div class="caption font-weight-bold">
                        {{ props.item.metricCaption2 }}
                      </div>
                      <div class="subheading">
                        {{ props.item.metric2 }}
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </td>
              <td>
                <div class="text-xs-left">
                  <v-chip
                    v-if="props.item.suggestion === 'no'"
                    color="error"
                    text-color="white"
                    >No
                  </v-chip>
                  <v-chip
                    v-else-if="props.item.suggestion === 'yes'"
                    color="success"
                    text-color="white"
                    >Yes
                  </v-chip>
                  <v-chip
                    v-else-if="props.item.suggestion === 'maybe'"
                    color="primary"
                    >May be
                  </v-chip>
                </div>
              </td>
              <td>
                <div>
                  <v-tooltip bottom>
                    <v-btn
                      icon
                      flat
                      :class="props.item.approved ? 'success' : 'error'"
                      :disabled="readOnly"
                      @click.stop="props.item.approved = !props.item.approved"
                      slot="activator"
                    >
                      <v-icon
                        >{{
                          props.item.approved === null ||
                          props.item.approved === ''
                            ? 'thumbs_up_down'
                            : props.item.approved
                            ? 'thumb_up_alt'
                            : 'thumb_down_alt'
                        }}
                      </v-icon>
                    </v-btn>
                    <span>Approve / Reject</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
          </template>
          <template v-slot:expand="props">
            <div class="pa-2">
              <v-card
                :class="$vuetify.dark ? 'card-dark ' : 'card-light'"
                v-for="(item, key) in items"
                :key="key + '-details-flex1'"
              >
                <v-card-title class="body-2 beez-bold">
                  Item Details
                  <v-spacer></v-spacer>
                  <v-btn
                    flat
                    icon
                    @click.stop="toggleAddInfo = !toggleAddInfo"
                    :disabled="!item.taskVariables"
                    :outline="$vuetify.dark"
                  >
                    <v-icon>
                      info
                    </v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-layout row wrap :key="key + '-details-layout2'">
                    <v-flex
                      grow
                      d-flex
                      style="padding: 10px"
                      :key="key2 + '-details-flex5'"
                      v-for="(attribute, key2) in item.attributes"
                    >
                      <div class="text-xs-left" :key="key2 + '-details-div5'">
                        <div
                          class="caption font-weight-bold"
                          :key="key2 + '-details-attribute-caption-5'"
                        >
                          {{ attribute.caption }}
                        </div>
                        <div
                          class="subheading"
                          :key="key2 + '-details-attribute5'"
                          v-if="isURL(attribute.value)"
                        >
                          <v-btn
                            flat
                            :href="attribute.value"
                            target="_blank"
                            class="text-capitalize"
                            :outline="$vuetify.dark"
                            :color="$vuetify.dark ? 'secondary' : 'primary'"
                          >
                            <v-icon>
                              reply
                            </v-icon>
                            <span class="pl-2">Open link</span>
                          </v-btn>
                        </div>
                        <div
                          class="subheading"
                          :key="key2 + '-details-attribute5'"
                          v-else
                        >
                          {{ attribute.value }}
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    :key="key + 'task_variables'"
                    v-if="toggleAddInfo && item.taskVariables"
                  >
                    <v-flex xs12>
                      <v-card
                        style="border-radius: 5px"
                        :class="$vuetify.dark ? 'card-dark ' : 'card-light'"
                      >
                        <state-variable-renderer
                          :key="key + 'task_variables-comp'"
                          :task-variables="item.taskVariables"
                        ></state-variable-renderer>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </div>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex v-else>
        <v-flex
          xs12
          style="padding: 1px"
          :key="key + '-flex1'"
          v-for="(item, key) in searchTerm ? fuseFilter : items"
        >
          <v-card
            hover
            flat
            dense
            :key="key + '-card'"
            style="border-radius: 5px"
          >
            <v-card-text :key="key + '-container'" @click="setSelectedKey(key)">
              <v-layout row wrap justify-space-between :key="key + '-layout'">
                <v-flex xs12 sm6 md3 :key="key + '-flex2'" class="mt-1">
                  <div
                    class="text-xs-left"
                    style="word-wrap: break-word"
                    :key="key + '-div'"
                  >
                    <div class="caption font-weight-bold" :key="key + '-name'">
                      {{ item.longDescription }}
                    </div>
                    <div class="subheading" :key="key + '-desc'">
                      {{ item.description }}
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12 sm6 md4 :key="key + '-flex3'" class="mt-1">
                  <div
                    class="text-xs-left"
                    :key="key + '-div2'"
                    style="word-wrap: break-word"
                  >
                    <div
                      class="caption font-weight-bold"
                      :key="key + '-metric-caption-1'"
                    >
                      {{ item.metricCaption1 }}
                    </div>
                    <div class="subheading" :key="key + '-metric1'">
                      {{ item.metric1 }}
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12 sm6 md3 :key="key + '-flex4'" class="mt-1">
                  <div
                    class="text-xs-left"
                    :key="key + '-div4'"
                    style="word-wrap: break-word"
                  >
                    <div
                      class="caption font-weight-bold"
                      :key="key + '-metric-caption-2'"
                    >
                      {{ item.metricCaption2 }}
                    </div>
                    <div class="subheading" :key="key + '-metric2'">
                      {{ item.metric2 }}
                    </div>
                  </div>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md3
                  :key="key + '-flex5'"
                  v-if="item.suggestion"
                  class="mt-1"
                >
                  <div class="text-xs-left" :key="key + '-div3'">
                    <div
                      class="caption font-weight-bold"
                      :key="key + '-sugg-caption-2'"
                    >
                      Suggestion
                    </div>
                    <v-chip
                      :key="key + '-suggestion-no'"
                      v-if="item.suggestion === 'no'"
                      color="error"
                      text-color="white"
                      >No
                    </v-chip>
                    <v-chip
                      :key="key + '-suggestion-yes'"
                      v-else-if="item.suggestion === 'yes'"
                      color="success"
                      text-color="white"
                      >Yes
                    </v-chip>
                    <v-chip
                      :key="key + '-suggestion-maybe'"
                      v-else-if="item.suggestion === 'maybe'"
                      color="primary"
                      >May be
                    </v-chip>
                  </div>
                </v-flex>
                <v-flex xs12 sm6 md2 :key="key + '-flex7'" class="mt-1">
                  <div
                    class="caption font-weight-bold"
                    :key="key + '-action-caption-2'"
                  >
                    Action
                  </div>
                  <v-tooltip bottom>
                    <v-btn
                      icon
                      :key="key + '-approve-btn'"
                      flat
                      :class="item.approved ? 'success' : 'error'"
                      :disabled="readOnly"
                      @click.stop="item.approved = !item.approved"
                      slot="activator"
                    >
                      <v-icon :key="key + '-approve-icon'"
                        >{{
                          item.approved === null || item.approved === ''
                            ? 'thumbs_up_down'
                            : item.approved
                            ? 'thumb_up_alt'
                            : 'thumb_down_alt'
                        }}
                      </v-icon>
                    </v-btn>
                    <span>Approve / Reject</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-expand-transition :key="key + '-showdetials-transition'">
              <v-flex>
                <v-card
                  :key="key + '-details-flex1'"
                  v-if="key === selectedApprovalKey"
                  :class="$vuetify.dark ? 'card-dark ' : 'card-light'"
                >
                  <v-card-title class="body-2 beez-bold">
                    Item Details
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      icon
                      @click.stop="toggleAddInfo = !toggleAddInfo"
                      :disabled="!item.taskVariables"
                      :outline="$vuetify.dark"
                    >
                      <v-icon>
                        info
                      </v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap :key="key + '-details-layout2'">
                      <v-flex
                        grow
                        d-flex
                        style="padding: 10px"
                        :key="key2 + '-details-flex5'"
                        v-for="(attribute, key2) in item.attributes"
                      >
                        <div class="text-xs-left" :key="key2 + '-details-div5'">
                          <div
                            class="caption font-weight-bold"
                            :key="key2 + '-details-attribute-caption-5'"
                          >
                            {{ attribute.caption }}
                          </div>
                          <div
                            class="subheading"
                            :key="key2 + '-details-attribute5'"
                            v-if="isURL(attribute.value)"
                          >
                            <v-btn
                              flat
                              :href="attribute.value"
                              target="_blank"
                              class="text-capitalize"
                              :outline="$vuetify.dark"
                              :color="$vuetify.dark ? 'secondary' : 'primary'"
                            >
                              <v-icon>
                                reply
                              </v-icon>
                              <span class="pl-2">Open link</span>
                            </v-btn>
                          </div>
                          <div
                            class="subheading"
                            :key="key2 + '-details-attribute5'"
                            v-else
                          >
                            {{ attribute.value }}
                          </div>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      row
                      wrap
                      :key="key + 'task_variables'"
                      v-if="toggleAddInfo && item.taskVariables"
                    >
                      <v-flex xs12>
                        <v-card
                          style="border-radius: 5px"
                          :class="$vuetify.dark ? 'card-dark ' : 'card-light'"
                        >
                          <state-variable-renderer
                            :key="key + 'task_variables-comp'"
                            :task-variables="item.taskVariables"
                          ></state-variable-renderer>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-expand-transition>
          </v-card>
        </v-flex>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import u from '@/utils'
import Fuse from 'fuse.js'
import StateVariableRenderer from '../common/form-generator/StateVariableRenderer'

export default {
  components: { StateVariableRenderer },
  name: 'UserApproval',
  props: {
    value: Array,
    readOnly: Boolean
  },
  computed: {
    totalApproved() {
      return this.items.filter(function(obj) {
        return obj.approved
      }).length
    },
    totalRejected() {
      return this.items.filter(function(obj) {
        return !obj.approved
      }).length
    }
  },
  data: () => {
    return {
      expand: false,
      headerPageItems: [5, 10, 25],
      tableView: true,
      approvalPanel: true,
      selectedApprovalKey: -1,
      searchTerm: '',
      headers: [
        { text: 'Description', value: 'description' },
        { text: 'Task Properties', value: 'metric1' },
        { text: 'Suggestion', value: 'suggestion' },
        { text: 'Approve/Reject', value: 'action', width: '150px' }
      ],
      toggleAddInfo: false,
      fuseOptions: {
        keys: ['name', 'description', 'longDescription']
      },
      fuseFilter: [],
      items: []
    }
  },
  created() {
    if (typeof this.value != 'undefined') {
      this.items = u.clone(this.value)
    }
  },
  watch: {
    items() {
      this.$emit('input', this.items)
    }
  },
  methods: {
    isURL(str) {
      var pattern = new RegExp(
        // eslint-disable-next-line no-useless-escape
        '(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
          '(\\#[-a-z\\d_]*)?$',
        'i'
      ) // fragment locator
      return pattern.test(str)
    },
    setSelectedKey(key) {
      if (this.selectedApprovalKey === key) {
        this.selectedApprovalKey = -1
      } else {
        this.selectedApprovalKey = key
      }
    },
    searchApprovalItems() {
      if (!this.tableView) {
        let fuse = new Fuse(this.items, this.fuseOptions)
        this.fuseFilter = fuse.search(this.searchTerm)
      }
    }
  }
}
</script>

<style scoped></style>
